export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9397.61a37b56.jpg";